import React from 'react';
import { Card, CardContent } from '../ui/card';
import { LineChart, Line, ResponsiveContainer } from 'recharts';

export default function CiScoreCard({ value, delta, history7d, subIndexes }) {
  const chartData = history7d.map((v) => ({ value: v }));
  
  const getSubIndexLabel = (key) => {
    const labels = {
      demandPulse: 'Demand Pulse',
      supplyHealth: 'Supply Health',
      priceVolatility: 'Price Volatility',
      creatorInfluence: 'Creator Influence',
      transactionVelocity: 'Transaction Velocity',
      logisticsStress: 'Logistics Stress'
    };
    return labels[key] || key;
  };
  
  return (
    <Card style={{ background: 'hsl(var(--card))', border: '1px solid hsl(var(--border))' }}>
      <CardContent className="p-6">
        <div className="mb-4">
          <div style={{ fontSize: '0.875rem', color: 'hsl(var(--muted-foreground))', marginBottom: '0.5rem' }}>
            Commerce Index
          </div>
          <div className="flex items-baseline gap-3">
            <div style={{ 
              fontSize: '4.5rem', 
              fontWeight: 700,
              fontFamily: 'monospace',
              lineHeight: 1,
              color: 'hsl(var(--foreground))'
            }}>
              {value}
            </div>
            <div style={{
              fontSize: '1.125rem',
              fontWeight: 600,
              color: delta >= 0 ? 'hsl(var(--success))' : 'hsl(var(--destructive))',
              fontFamily: 'monospace'
            }}>
              {delta >= 0 ? '+' : ''}{delta}
            </div>
          </div>
          <div style={{ fontSize: '0.75rem', color: 'hsl(var(--muted-foreground))', marginTop: '0.5rem' }}>
            Updated {new Date().toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
          </div>
        </div>

        {/* 7-day sparkline */}
        <div style={{ height: 60, marginBottom: '1.5rem' }}>
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={chartData}>
              <Line 
                type="monotone" 
                dataKey="value" 
                stroke="#2176FF" 
                strokeWidth={2}
                dot={false}
              />
            </LineChart>
          </ResponsiveContainer>
        </div>

        {/* Sub-indexes */}
        <div className="mt-4">
          <div style={{ 
            fontSize: '0.75rem', 
            fontWeight: 600,
            color: '#8A90A2',
            marginBottom: '1rem',
            letterSpacing: '0.05em'
          }}>
            COMPONENTS
          </div>
          <div className="space-y-3">
            {Object.entries(subIndexes).map(([key, value]) => (
              <div key={key}>
                <div className="flex justify-between mb-1" style={{ fontSize: '0.75rem' }}>
                  <span style={{ color: 'hsl(var(--muted-foreground))' }}>{getSubIndexLabel(key)}</span>
                  <span style={{ color: 'hsl(var(--foreground))', fontFamily: 'monospace' }}>
                    {(value * 100).toFixed(0)}
                  </span>
                </div>
                <div style={{ 
                  width: '100%', 
                  height: 6, 
                  background: 'hsl(var(--muted))',
                  borderRadius: 3,
                  overflow: 'hidden'
                }}>
                  <div style={{ 
                    width: `${value * 100}%`, 
                    height: '100%',
                    background: key === 'logisticsStress' 
                      ? (value > 0.5 ? 'hsl(var(--destructive))' : 'hsl(var(--warning))')
                      : 'hsl(var(--primary))',
                    transition: 'width 0.3s ease'
                  }} />
                </div>
              </div>
            ))}
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
